import { useEffect, useState } from 'react';

/**
 * Возвращает debounced-значение: обновляется с задержкой delay мс после изменения value.
 */
export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const tid = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(tid);
  }, [value, delay]);

  return debouncedValue;
}
